export namespace DateUtil {
  export function compareDates(date1: Date, date2: Date): number {
    if (date1 < date2) {
      return -1;
    } else if (date1 > date2) {
      return 1;
    }
    return 0;
  }

  export function isBefore(date1: Date, date2: Date): boolean {
    return compareDates(date1, date2) === -1;
  }

  export function isAfter(date1: Date, date2: Date): boolean {
    return compareDates(date1, date2) === 1;
  }

  /**
   * dateRangeIsContained - returns true if the first date range is completely contained by the second date range.
   * @param startDate - the start of the first date range
   * @param endDate - the end of the first date range
   * @param otherStartDate - the start of the date range that might contain the first date range
   * @param otherEndDate - the end of the date range that might contain the first date range
   * @returns {boolean}
   */
  export function dateRangeIsContained(startDate: Date, endDate: Date, otherStartDate: Date, otherEndDate: Date): boolean {
    return compareDates(startDate, otherStartDate) >= 0 && compareDates(endDate, otherEndDate) <= 0;
  }
}
